import visszahivasKeresFormTemplate from './visszahivas-keres-form.pug';
import {EMAIL_PATTERN, PHONE_PATTERN, SIMPLE_TEXT_PATTERN} from '../../../common/constants/consts';
import uuidv1 from 'uuid/v1';
import vcRecaptcha from 'angular-recaptcha';
import RefreshSelects from './../../../common/utils/refresh-selects';
const MODULE_NAME = 'visszahivasKeresForm';

class VisszahivasKeresFormController extends RefreshSelects {
	constructor($rootScope, vcRecaptchaService, $element) {
		'ngInject';
		super($element);
		this.rootScope = $rootScope;
		this.uuid = uuidv1;
		this.vcRecaptchaService = vcRecaptchaService;
		this.$element = $element[0];
	}
	$onInit() {
		this.model = {};
		this.adatvedelmiIsChecked = false;
		this.error = false;
		this.patterns = {
			email: EMAIL_PATTERN,
			phone: PHONE_PATTERN,
			simpleText: SIMPLE_TEXT_PATTERN
		};
	}
	$onChanges(changeObject) {
		if (changeObject.initData && changeObject.initData.currentValue) {
			this.targyak = angular.copy(this.initData.targyak);
			this.visszahivasIdok = angular.copy(this.initData.visszahivasIdok);
			this.captchaUrl = angular.copy(this.initData.captchaUrl);
			this.model.captchaId = angular.copy(this.initData.captchaId);
			this.rerenderNativeSelects();
		}
		if (changeObject.errors && changeObject.errors.currentValue) {
			this.resetCaptcha();
			this.serverError = angular.copy(this.errors.data.errors);
			this.serverError.forEach((item) => {
				if (item.field == 'captcha' && item.message == 'invalid') {
					this.model.captchaValue = '';
					this.visszahivasKeresForm.captcha.$error.serverError = true;
				} else {
					this.rootScope.$broadcast('serverError');
				}
			});
		}
		if (changeObject.success && changeObject.success.currentValue) {
			if (this.success) {
				this.resetForm();
			}
		}
	}
	resetForm() {
		this.visszahivasKeresForm.$setPristine();
		this.visszahivasKeresForm.$setUntouched();
		this.model = angular.copy({});
		this.adatvedelmiIsChecked = false;
		this.model.captchaId = this.uuid();
		this.resetCaptcha();
	}
	postVisszahivasKeresForm() {
		if (this.visszahivasKeresForm.$valid) {
			this.postForm({
				data: this.model
			});
		}
	}
	getCaptcha() {
		let now = new Date().getTime();
		this.captchaImage = this.captchaUrl.replace('{id}', `${this.model.captchaId}?${now}`);
	}

	changeOiselect(subjectId) {
		this.model.subjectId = subjectId;
	}

	resetCaptcha() {
		this.vcRecaptchaService.reload();
	}

	changeNativeSelect(subjectId) {
		for (let restTargy of this.restTargyak) {
			if (restTargy.subjectId == subjectId) {
				this.oiSelectModel = restTargy;
			}
		}
	}
}

export default angular.module(MODULE_NAME, [vcRecaptcha])
	.component(MODULE_NAME, {
		controller: VisszahivasKeresFormController,
		template: visszahivasKeresFormTemplate(),
		bindings: {
			id: '<',
			initData: '<',
			errors: '<',
			postForm: '&',
			success: '<',
			documentUrl: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/visszahivas-keres/visszahivas-keres-form/visszahivas-keres-form.js